export class DataQueryParameter {
	DataType: string;
	FunctionId: number;
	Id: number;
	Name: string;
	Position: number;
}